<template>
  <div>
    <div class="card-inner">
      <div class="preview-block">
        <span class="preview-title-lg overline-title">Footer</span>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">Company</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.company" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">Street</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.street" type="text" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">City</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.city" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6"></div>
        </div>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">Phone</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.phone" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">Mobile</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.mobile" type="text" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="row gy-4">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">E-Mail</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.email"  type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label" for="default-01">Web</label>
              <div class="form-control-wrap">
                <input v-model="report_settings.web"  type="text" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <hr class="preview-hr" /> 
        <div class="form-group"> 
          <div v-if="infoSaved" class="alert alert-success alert-icon">
            <em class="icon ni ni-check-circle"></em> Saved
          </div>
          <button
            type="submit"
            class="btn btn-lg btn-primary"
            @click="saveForm()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  saveMainReportSettings
} from "@/services/reporting.service";

export default {
  name: "ReportFooter",
  components: {
   

  },
  data() {
    return {
      infoSaved: false
    };
  },
  computed: {
    report_settings: function () {
      return this.$store.state.rp_report_settings;
    },
  },

  methods: {
    saveForm: function () {
        saveMainReportSettings(this.$store.state.rp_report_settings).then( d => {
            console.log("d", d)
        })
    }
  }

};
</script>

<style>
</style>